/**
 * How dispatch names a piece of equipment: SERIAL first, name second.
 *
 * On TNT the serial is the tool's identity ("TN 2300") and the name is its
 * description ("8 5/8 Ltc pin X NC40 box") — several tools share a description,
 * none share a serial. The dispatch board used to print the name alone, which
 * named the description and not the tool.
 *
 * Either half may be absent. An absent half is dropped rather than replaced
 * with a placeholder; with neither, the label is an em dash.
 */
export function equipmentLabel(serial: string | null | undefined, name: string | null | undefined): string {
  const s = typeof serial === 'string' ? serial.trim() : '';
  const n = typeof name === 'string' ? name.trim() : '';
  if (s && n && s !== n) return `${s} · ${n}`;
  return s || n || '—';
}
